/**
 * @generated SignedSource<<980217fdffb1f936a9df41f473078a27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegatedAccessModalQuery$variables = {};
export type DelegatedAccessModalQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly hasAccessToDelegatedAccess: boolean;
      };
    };
    readonly delegates: ReadonlyArray<{
      readonly delegate: {
        readonly id: string;
      };
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"DelegateCard_Delegation">;
    }>;
    readonly delegators: ReadonlyArray<{
      readonly delegator: {
        readonly id: string;
      };
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"DelegateCard_Delegation">;
    }>;
    readonly user: {
      readonly id: string;
    };
  };
};
export type DelegatedAccessModalQuery = {
  response: DelegatedAccessModalQuery$data;
  variables: DelegatedAccessModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v3 = {
  "alias": "hasAccessToDelegatedAccess",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "delegated_access"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"delegated_access\")"
},
v4 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "DelegateCard_Delegation"
},
v5 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "image",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "delegator",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiryDate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastAccessed",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "delegate",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DelegatedAccessModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Delegation",
            "kind": "LinkedField",
            "name": "delegators",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "delegator",
                "plural": false,
                "selections": (v1/*: any*/),
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Delegation",
            "kind": "LinkedField",
            "name": "delegates",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "delegate",
                "plural": false,
                "selections": (v1/*: any*/),
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DelegatedAccessModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Delegation",
            "kind": "LinkedField",
            "name": "delegators",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Delegation",
            "kind": "LinkedField",
            "name": "delegates",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v10/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "60344f760c6657a4547d8b9cac339e2f",
    "id": null,
    "metadata": {},
    "name": "DelegatedAccessModalQuery",
    "operationKind": "query",
    "text": "query DelegatedAccessModalQuery {\n  viewer {\n    user {\n      id\n    }\n    account {\n      billingAccount {\n        hasAccessToDelegatedAccess: hasAccessToFeature(feature: delegated_access)\n        id\n      }\n      id\n    }\n    delegators {\n      id\n      delegator {\n        id\n      }\n      ...DelegateCard_Delegation\n    }\n    delegates {\n      id\n      delegate {\n        id\n      }\n      ...DelegateCard_Delegation\n    }\n    id\n  }\n}\n\nfragment DelegateCard_Delegation on Delegation {\n  id\n  expiryDate\n  lastAccessed\n  createdAt\n  delegator {\n    id\n    fullName\n    email\n    image\n  }\n  delegate {\n    id\n    fullName\n    email\n    image\n  }\n}\n"
  }
};
})();

(node as any).hash = "95a6ec560acd691d0a858f6ecf45cf9b";

export default node;
